module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-a2e3e4cc6d9da76eaab16639b2c78c11.png";